<template>
  <router-link :to="go_to()" class="specification link">
    <tr>
      <td :data-label="translate('specification.id')" class="w50">
        {{ spec_item.id }}
      </td>
      <td :data-label="translate('specification.date')" class="w120">
        {{ spec_item.date }}
      </td>
      <td :data-label="translate('specification.spec_number')" class="w120">
        {{ spec_item.spec_number }}
      </td>
      <td :data-label="translate('specification.client')" class="w120">
        {{ get_client_name(spec_item.client_id) }}
      </td>
      <td :data-label="translate('specification.name')" class="name">
        <p class="limit">
          {{ spec_item.name }}
        </p>
      </td>
      <td :data-label="translate('specification.positions')" class="w120">
        {{ spec_item.items_count }}
      </td>
      <td :data-label="translate('specification.devices')" class="w120">
        {{ `${spec_item.ready_devices} / ${spec_item.total_devices}` }}
      </td>
      <td :data-label="translate('specification.planned_finish_date')" class="w120">
        {{ spec_item.planned_finish_date }}
      </td>
      <td :data-label="translate('specification.descr')" class="name">
        <p class="limit">
          {{ spec_item.descr }}
        </p>
      </td>
      <td :data-label="translate('specification.user')" class="w120">
        {{ get_user_name(spec_item.user_id) }}
      </td>
      <td :data-label="translate('specification.status')" class="w120">
        <span class="badge" :style="'background-color: ' + new_status.color">
          {{ new_status.descr }}
        </span>
      </td>
      <td :data-label="translate('specification.updated_at')" class="w120">
        {{ get_date(spec_item.updated_at, ts_date_options) }}
      </td>
      <td class="w50" @click.prevent.stop="">
        <span
            class="mdi mdi-content-copy pointer"
            @click="copy_production_plan(spec_item.id)"
        />
      </td>
    </tr>
  </router-link>
</template>
<script>

export default {
  name: 'SpecItem',
  components: {
  },
  props: ["spec_item"],
  data () {
    return {
      ts_date_options:{
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }
    }
  },
  computed:{
    new_status(){
      let new_status = this.spec_item.status !== null ? this.spec_item.status : 0

      let result = this.$store.getters.getClientOrderSpecs.statuses.find((entry) => {
        if (entry.id === new_status){
          return entry
        }
      })

      return result ? result : {descr: "Error", color: "red"}
    }
  },
  methods: {
    copy_production_plan(spec_id){
      this.$http.v1.copySpecification(spec_id, {}, (response) => {
        this.global_notify('info', this.translate('client_order.saved_success'))
        this.$router.push({path: '/specification/' + response.data.id})
      })
    },
    get_client_name(client_id){
      const client = this.$store.getters.getClientsList.find((client) => {
        if (client.id === client_id) return client
      })
      return client ? client.name : ""
    },
    get_user_name(user_id){
      const user = this.$store.getters.getCompanyUserList.find((user) => {
        if (user.id === user_id) return user
      })
      return user ? user.name : ""
    },
    go_to() {
      return { path: '/specification/' + this.spec_item.id }
    },

  }
}
</script>

<style lang="scss" scoped>
.specification{
  cursor: pointer;
  color: #252422;
  &:hover{
    tr{
      background-color: #eee;
    }
  }
  td{
    overflow: hidden;
    font-size: 14px;
  }
  .level{
    display: inline-block;
    width: 20px;
    height: 100%;
  }
  .w180{
    max-width: 180px;
    width: 180px;
  }
  .w100{
    max-width: 100px;
    width: 100px;
  }
  .w120{
    max-width: 120px;
    width: 120px;
  }
  .w50{
    max-width: 50px;
    width: 50px;
  }
  .has_child{
    background-color: #eee;
    font-weight: bold;
  }
  .name{
    text-align: center;
    @media (max-width: 750px) {
      text-align: right;
    }
  }
  .inn{
    text-align: left;
  }
  .limit{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5em;
    max-height: 3em;
    margin-bottom: 0;
    font-size: 14px;
  }
}
</style>
